import { t } from "i18next";
import { useState } from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import MDBox from "components/Basics/MDBox";
import MDButton from "components/Basics/MDButton";
import MDTypography from "components/Basics/MDTypography";
import MDInput from "components/Basics/MDInput";

/**
 * Item for each language
 * @param {*} param0
 * @returns
 */
const LanguageItem = ({ language, exists = false, onSave = () => {} }) => {
	return (
		<MDBox
			m={1}
			display="flex"
			alignItems="center"
			justifyContent="space-between"
			sx={{
				userSelect: "none",
				backgroundColor: exists ? "#f5f5f5" : "#ffffff",
				cursor: exists ? "" : "pointer",
				"&:hover": { backgroundColor: exists ? "#f5f5f5" : "#f0f0f0" },
				border: "1px solid #e0e0e0",
				borderRadius: "8px",
				padding: "10px"
			}}
			onClick={() => {
				if (!exists) {
					onSave(language);
				}
			}}
		>
			<MDBox display="flex" alignItems="center">
				<MDBox
					sx={{
						height: "100%",
						width: "100%"
					}}
					component="img"
					src={language.logoURL}
					style={{ height: "1.5rem", width: "2rem", objectFit: "contain" }}
				/>
				<MDTypography
					fontWeight="bold"
					sx={{
						ml: 2
					}}
					fontSize="small"
				>
					{language.name}
				</MDTypography>
			</MDBox>

			{exists && (
				<MDTypography
					fontWeight="regular"
					sx={{
						ml: 2,
						color: "#888888"
					}}
					fontSize="small"
				>
					Déjà importée
				</MDTypography>
			)}
		</MDBox>
	);
};

/**
 * Form V2 Dialog (language)
 * @param {*} param0
 * @returns
 */
const LanguageDialog = ({
	open = false,
	onClose = () => {},
	onSave = () => {},
	languages = [],
	assistantLanguages = []
}) => {
	const [searchTerm, setSearchTerm] = useState("");

	const languageAlreadyImported = code => {
		return assistantLanguages.includes(code);
	};

	const filteredLanguages = languages.filter(language => {
		if (!searchTerm) return true;
		const searchLower = searchTerm.toLowerCase();
		return (
			language.name?.toLowerCase().includes(searchLower) ||
			language.code?.toLowerCase().includes(searchLower) ||
			language.description?.toLowerCase().includes(searchLower)
		);
	});

	return (
		<Dialog
			open={open}
			fullWidth
			maxWidth="md"
			onClose={onClose}
			PaperProps={{
				style: {
					height: "80%",
					width: "100%",
					maxWidth: "60%"
				}
			}}
		>
			<DialogTitle>
				<MDBox display="flex" justifyContent="space-between" alignItems="center">
					<MDBox flex="2">
						<MDTypography variant="h5">Ajouter une langue</MDTypography>
						<MDTypography variant="subtitle2">{`${assistantLanguages.length}/${languages.length} importées`}</MDTypography>
					</MDBox>
					<MDBox flex="3">
						<MDInput
							placeholder="Rechercher par nom, code ou description..."
							value={searchTerm}
							onChange={e => setSearchTerm(e.target.value)}
							size="small"
							fullWidth
						/>
					</MDBox>
				</MDBox>
			</DialogTitle>
			<DialogContent>
				<MDBox>
					{filteredLanguages.map(language => {
						return (
							<LanguageItem
								key={language.code}
								language={language}
								onSave={onSave}
								exists={languageAlreadyImported(language.code)}
							/>
						);
					})}
				</MDBox>
			</DialogContent>
			<DialogActions>
				<MDButton onClick={onClose} variant="outlined" color="info">
					{t("FORMS.cancel")}
				</MDButton>
			</DialogActions>
		</Dialog>
	);
};

export default LanguageDialog;
